import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AirSearchComponent } from "./air-search.component";
import { CardModule } from "libraries/ui_card/card.module";
import { AirSearchHeaderComponent } from './air-search-header/air-search-header.component';
import {
    AirSearchHeaderActionComponent
} from './air-search-header/air-search-header-action/air-search-header-action.component';
import { AirSearchFormComponent } from './air-search-form/air-search-form.component';
import { AirSearchResumeComponent } from './air-search-resume/air-search-resume.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    AirSearchQuantityFormComponent
} from './air-search-form/air-search-quantity-form/air-search-quantity-form.component';
import { NumberModule } from 'libraries/module/formbuilder/fields/number/number.module';
import { ButtonModule } from 'libraries/module/formbuilder/fields/button/button.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { PermissionModule } from 'libraries/permission/permission.module';
import { RouterModule } from '@angular/router';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DatePipeModule } from 'libraries/date/date.module';
import { HostAliasPipeModule } from 'libraries/pipes/host-alias/host-alias-pipe.module';
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';
import {
    AirSearchKeywordFormComponent
} from './air-search-form/air-search-keyword-form/air-search-keyword-form.component';
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";
import {
    AirSearchFlexibilityFormComponent
} from './air-search-form/air-search-flexibility-form/air-search-flexibility-form.component';
import { ComboboxFieldModule } from "libraries/module/formbuilder/fields/combobox-field/combobox-field.module";
import { AirSearchCabinFormComponent } from './air-search-form/air-search-cabin-form/air-search-cabin-form.component';

import { AirportSelectModule } from "libraries/component/airport-select/airport-select.module";
import {
    AirSearchMaxViasFormComponent
} from './air-search-form/air-search-max-vias-form/air-search-max-vias-form.component';
import {
    AirSearchLocatorFormComponent
} from './air-search-form/air-search-locator-form/air-search-locator-form.component';
import { AirSearchHostFormComponent } from './air-search-form/air-search-host-form/air-search-host-form.component';
import { CheckboxFieldModule } from "libraries/module/formbuilder/fields/checkbox-field/checkbox-field.module";
import { DateModule } from "libraries/module/formbuilder/fields/date/date.module";
import { AirSearchPriceFormComponent } from './air-search-form/air-search-price-form/air-search-price-form.component';
import { PriceFieldsetModule } from 'libraries/module/formbuilder/fieldsets/price-fieldset/price-fieldset.module';
import { AirSearchCarrierFormComponent } from './air-search-form/air-search-carrier-form/air-search-carrier-form.component';
import { AirSearchFareTypeFormComponent } from './air-search-form/air-search-fare-type-form/air-search-fare-type-form.component';
import { ChipsFieldModule } from 'libraries/module/formbuilder/fields/chips-field/chips-field.module';
import { ToggleModule } from 'libraries/component/toggle/toggle.module';
import {
    AirSearchSegmentMultipleComponent
} from "./air-search-form/air-search-segment-multiple/air-search-segment-multiple.component";
import {
    AirSearchSegmentOnewayReturnComponent
} from "./air-search-form/air-search-segment-oneway-return/air-search-segment-oneway-return.component";
import {TimeFieldModule} from "libraries/module/formbuilder/fields/time/time-field.module";
import {TextFieldModule} from "libraries/module/formbuilder/fields/text-field/text-field.module";
import {MatCheckboxModule} from "@angular/material/checkbox";
import { AirSearchResourceModule } from "libraries/service/resources/air-search-resource/air-search-resource.module";
import {CalendarModule} from "primeng/calendar";
import {MatInputModule} from "@angular/material/input";


@NgModule({
    declarations: [
        AirSearchComponent,
        AirSearchHeaderComponent,
        AirSearchHeaderActionComponent,
        AirSearchFormComponent,
        AirSearchResumeComponent,
        AirSearchQuantityFormComponent,
        AirSearchKeywordFormComponent,
        AirSearchFlexibilityFormComponent,
        AirSearchCabinFormComponent,
        AirSearchSegmentOnewayReturnComponent,
        AirSearchMaxViasFormComponent,
        AirSearchLocatorFormComponent,
        AirSearchLocatorFormComponent,
        AirSearchHostFormComponent,
        AirSearchPriceFormComponent,
        AirSearchCarrierFormComponent,
        AirSearchFareTypeFormComponent,
        AirSearchSegmentMultipleComponent
    ],
    imports: [
        CommonModule,
        CardModule,
        ReactiveFormsModule,
        NumberModule,
        ButtonModule,
        BtnModule,
        PermissionModule,
        RouterModule,
        LoaderModule,
        FontAwesomeModule,
        DatePipeModule,
        LoaderModule,
        MultiselectModule,
        ComboboxFieldModule,
        PricePipeModule,
        HostAliasPipeModule,
        AirportSelectModule,
        CheckboxFieldModule,
        DateModule,
        FormsModule,
        PriceFieldsetModule,
        ChipsFieldModule,
        ToggleModule,
        TimeFieldModule,
        TextFieldModule,
        MatCheckboxModule,
        AirSearchResourceModule,
        CalendarModule,
        MatInputModule,
    ],
    exports: [
        AirSearchComponent
    ]
})
export class AirSearchModule {
}
